// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"d47001c2","325":"8afede74","418":"11523d6c","486":"6808c130","588":"e6f96812","683":"2e86357e","775":"e28e926a","906":"1723f4c6","956":"ec918820","973":"6b8e5fc4"}[chunkId] + ".chunk.css";
};